export const ru = {
    active: 'Принята',
    archived: 'Перенесена в архив',
    'completed-by-client': 'Отклонена агентством',
    'completed-by-date': 'Завершена по дате',
    'completed-by-publisher': 'Отменена площадкой',
    'preferred-deal': 'Частная сделка',
    private_marketplace: 'Приватный аукцион',
    received: 'Получена'
};
